import { useCallback, useMemo, useRef } from "react";
import { useAppStateProvider } from "../../../contextProviders/AppStateProvider";
import createTranslator from "../../../util/translationHelper";
import messages from "./translations/messages";

function useEligibilityModal() {
  const BLOCK = useRef("eligibility-modal");
  const { appState, updateAppStateLocal } = useAppStateProvider();
  const translate = useMemo(() => createTranslator(messages), []);

  const isOpen = appState?.eligibilityModalOpen || false;
  const eligibility = appState?.qboConnectionEligibility;

  const variant =
    eligibility === "multiple_mids"
      ? "multiple-mids"
      : eligibility === "mid_already_connected"
      ? "mid-already-connected"
      : eligibility === "no_mids_assigned"
      ? "no-mid"
      : null;

  const handleClose = useCallback(() => {
    updateAppStateLocal({ eligibilityModalOpen: false });
  }, [updateAppStateLocal]);

  return {
    BLOCK,
    isOpen,
    variant,
    handleClose,
    translate,
  };
}

const Hook = {
  useEligibilityModal,
};

export default Hook;
